import React from "react";
import { Moon, Sun } from "lucide-react";
import { useTheme } from "../../theme/useTheme";

/** Small sun/moon button that flips the app-wide light/dark theme. */
const ThemeToggleButton: React.FC<{ className?: string }> = ({ className = "" }) => {
  const { theme, toggleTheme } = useTheme();
  const label = theme === "light" ? "Switch to dark theme" : "Switch to light theme";
  return (
    <button
      type="button"
      role="switch"
      aria-checked={theme === "light"}
      aria-label={label}
      title={label}
      onClick={toggleTheme}
      className={`flex h-9 w-9 items-center justify-center rounded-full border transition hover:brightness-110 ${className}`}
      style={{
        background: "var(--astria-surface-soft)",
        borderColor: "var(--astria-accent-glow)",
        color: "var(--astria-accent-primary)",
      }}
    >
      {theme === "light" ? <Moon className="h-4 w-4" /> : <Sun className="h-4 w-4" />}
    </button>
  );
};

export default ThemeToggleButton;
